import styled from 'styled-components';

export const StyledVideoEmbedded = styled.div`
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 56.25%;

  > * {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
`;
